import React, { useMemo, useState } from 'react'
import { Box, Button, Flex, Table, Text } from '@workwhile/ui'
import { Plus } from 'lucide-react'
import { AccordionCard } from 'components/AccordionCard'
import { TableEmptyState } from 'components/Table/TableEmptyState'
import { useSelectedColumns } from './ColumnsFilter/useSelectedColumns'
import { usePaginationQueryState } from 'lib/nuqs/usePaginationQueryState'
import { useRequirementDetailContextValue } from '../context/RequirementDetailProvider'
import { AddQuestionModal } from './AddQuestionModal'

const QuestionsTable = () => {
  const {
    state: { questions },
  } = useRequirementDetailContextValue()
  const [pagination, setPagination] = usePaginationQueryState({
    defaultPageSize: 10,
    urlKeys: {
      pageIndex: 'questions-page',
      pageSize: 'questions-page-size',
    },
  })

  const columns = useSelectedColumns()

  const sortedQuestions = useMemo(
    () =>
      questions.toSorted((a, b) => {
        if (a.deletedAt === null && b.deletedAt !== null) return -1
        if (a.deletedAt !== null && b.deletedAt === null) return 1
        return 0
      }),
    [questions]
  )

  if (sortedQuestions.length === 0) {
    return (
      <TableEmptyState isFetching={false} emptyMessage="No questions found" />
    )
  }

  return (
    <Box>
      <Table
        columns={columns}
        data={sortedQuestions}
        clientPagination={{ state: pagination, setState: setPagination }}
      />
    </Box>
  )
}

export const Questions = () => {
  const {
    state: { id: requirementId },
  } = useRequirementDetailContextValue()
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)

  return (
    <>
      <AccordionCard
        title={
          <Flex justifyContent="space-between" alignItems="center" gap={2}>
            <Text fontSize={2} color="lightText">
              Questions
            </Text>
            <Button
              kind="small"
              variant="primary"
              onClick={() => setIsAddModalOpen(true)}
            >
              <Flex gap={2} alignItems="center">
                <Plus size={14} />
                Add
              </Flex>
            </Button>
          </Flex>
        }
        size="large"
        contentWrapperProps={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <QuestionsTable />
      </AccordionCard>
      <AddQuestionModal
        requirementId={requirementId}
        open={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
      />
    </>
  )
}
